// Environment Controls
export const SET_BACKGROUND_SOLID = "SET_BACKGROUND_SOLID";
export const SET_BACKGROUND_ENVIRONMENT = "SET_BACKGROUND_ENVIRONMENT";
export const SET_BACKGROUND_COLOR = "SET_BACKGROUND_COLOR";
export const SET_ENVIRONMENT_OPTION = "SET_ENVIRONMENT_OPTION";
export const TOGGLE_MAP_ENVIRONMENT = "TOGGLE_MAP_ENVIRONMENT";
export const RESET_ENVIRONMENT_CONTROLS = "RESET_ENVIRONMENT_CONTROLS";
export const BULK_SET_ENVIRONMENT_CONTROLS = "BULK_SET_ENVIRONMENT_CONTROLS";
//

// Projects
export const NEW_PROJECT = "NEW_PROJECT";
export const UPDATE_PROJECT_DETAILS = "UPDATE_PROJECT_DETAILS";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const POPULATE_PROJECTS = "POPULATE_PROJECTS";
export const SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT";
export const SET_PROJECT_START = "SET_PROJECT_START";
export const SET_PROJECT_END = "SET_PROJECT_END";
//

// Themes
export const SET_THEME = "SET_THEME";

// Mode selector
export const MODE_SELECT = "MODE_SELECT";
//

// Current Model
export const SET_MODEL = "SET_MODEL";
export const SET_FOV = "SET_FOV";
export const SET_FAR = "SET_FAR";
export const SET_NEAR = "SET_NEAR";
export const SET_SIZE_BOUNDING = "SET_SIZE_BOUNDING";
export const SET_BOX = "SET_BOX";
export const RESET_EDIT_STATE = "RESET_EDIT_STATE";
export const SET_SELECTED_PART = "SET_SELECTED_PART";
//

// Camera Controls
export const SET_CAMERA_MODE = "SET_CAMERA_MODE";
//

// Extra Controls
export const TOGGLE_LOCK = "TOGGLE_LOCK";
export const TOGGLE_BOUNDING_BOX = "TOGGLE_BOUNDING_BOX";
export const TOGGLE_AXIS = "TOGGLE_AXIS";
export const TOGGLE_AUTOROTATE = "TOGGLE_AUTOROTATE";
export const RESET_EXTRA_CONTROLS = "RESET_EXTRA_CONTROLS";
//

// Appearance Controls
export const SET_SELECTED_MATERIAL = "SET_SELECTED_MATERIAL";
export const UPDATE_MATERIALS = "UPDATE_MATERIALS";
export const UPDATE_ENTIRE_MATERIALS = "UPDATE_ENTIRE_MATERIALS";
export const RESET_APPEARANCE_CONTROLS = "RESET_APPEARANCE_CONTROLS";
//

// Media State
export const SET_MEDIA_MODEL = "SET_MEDIA_MODEL";
export const SET_MEDIA_FOV = "SET_MEDIA_FOV";
export const SET_MEDIA_FAR = "SET_MEDIA_FAR";
export const SET_MEDIA_NEAR = "SET_MEDIA_NEAR";
export const SET_MEDIA_SIZE_BOUNDING = "SET_MEDIA_SIZE_BOUNDING";
export const SET_MEDIA_BOX = "SET_MEDIA_SET_BOX";
export const SET_MEDIA_ENV_BACKGROUND = "SET_MEDIA_ENV_BACKGROUND";
export const SET_MEDIA_SOLID_BACKGROUND = "SET_MEDIA_SOLID_BACKGROUND";
export const SET_DRAG_OBJECTS = "SET_DRAG_OBJECTS";
export const RESET_MEDIA_STATE = "RESET_MEDIA_STATE";
//

// Media Controls
export const TOGGLE_MAP_ENV = "TOGGLE_MAP_ENV";
export const TOGGLE_MEDIA_ENV_B = "TOGGLE_MEDIA_ENV_B";
export const TOGGLE_MEDIA_SOLID_B = "TOGGLE_MEDIA_SOLID_B";
export const TOGGLE_MEDIA_NO_B = "TOGGLE_MEDIA_NO_B";
export const TOGGLE_MEDIA_LOCK = "TOGGLE_LOCK";
export const TOGGLE_MEDIA_BOUNDING_BOX = "TOGGLE_BOUNDING_BOX";
export const TOGGLE_MEDIA_AXIS = "TOGGLE_AXIS";
export const TOGGLE_MEDIA_AUTOROTATE = "TOGGLE_AUTOROTATE";
export const TOGGLE_DEFAULT_LIGHT = "TOGGLE_DEFAULT_LIGHT";
export const SET_MEDIA_SPHERE = "SET_MEDIA_SPHERE";
export const SET_MEDIA_L_SPHERE = "SET_MEDIA_L_SPHERE";
export const SET_MEDIA_M_BOX = "SET_MEDIA_M_BOX";
export const SET_MEDIA_W_BOX = "SET_MEDIA_W_BOX";
export const SET_MEDIA_KEY_LIGHT = "SET_MEDIA_KEY_LIGHT";
export const SET_MEDIA_D_LIGHT = "SET_MEDIA_D_LIGHT";
export const SET_MEDIA_B_LIGHT = "SET_MEDIA_B_LIGHT";
export const SET_MEDIA_P_WALL = "SET_MEDIA_P_WALL";
export const SET_MEDIA_P_GROUND = "SET_MEDIA_P_GROUND";
export const RESET_MEDIA_CONTROLS = "RESET_MEDIA_CONTROLS";
export const TOGGLE_USER_MODEL_DRAG = "TOGGLE_USER_MODEL_DRAG";
//

// Light Controls
export const SET_AMBIENT_LIGHT_INTENSITY = "SET_AMBIENT_LIGHT_INTENSITY";
export const SET_DIRECTIONAL_LIGHT_INTENSITY =
  "SET_DIRECTIONAL_LIGHT_INTENSITY";
export const SET_HEMISPHERE_LIGHT_INTENSITY = "SET_HEMISPHERE_LIGHT_INTENSITY";
export const SET_AMBIENT_LIGHT_COLOR = "SET_AMBIENT_LIGHT_COLOR";
export const SET_DIRECTIONAL_LIGHT_COLOR = "SET_DIRECTIONAL_LIGHT_COLOR";
export const SET_HEMISPHERE_LIGHT_COLOR = "SET_HEMISPHERE_LIGHT_COLOR";
export const TOGGLE_HEMISPHERE_LIGHT = "TOGGLE_HEMISPHERE_LIGHT";
export const TOGGLE_AMBIENT_LIGHT = "TOGGLE_AMBIENT_LIGHT";
export const TOGGLE_DIRECTIONAL_LIGHT = "TOGGLE_DIRECTIONAL_LIGHT";
export const RESET_LIGHTS = "RESET_LIGHTS";
export const BULK_SET_LIGHT_CONTROLS = "BULK_SET_LIGHT_CONTROLS";
//

// Configurations
export const SET_CURRENT_CONFIGURATION_ID = "SET_CURRENT_CONFIGURATION_ID";
export const SET_CURRENT_CONFIGURATION_NAME = "SET_CURRENT_CONFIGURATION_NAME";
export const SET_CONFIGURATION_SAVED = "SET_CONFIGURATION_SAVED";
export const SET_CONFIGURATION_UNSAVED = "SET_CONFIGURATION_UNSAVED";
export const SET_ALL_CONFIGURATIONS = "SET_ALL_CONFIGURATIONS";
export const ADD_CONFIGURATION = "ADD_CONFIGURATION";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const UPDATE_CONFIGURATION = "UPDATE_CONFIGURATION";
export const RESET_CONFIGURATIONS = "RESET_CONFIGURATIONS";
//

// Users
export const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";
//

// Part Model
export const SET_PART_MODEL = "SET_PART_MODEL";
export const SET_PART_FOV = "SET_PART_FOV";
export const SET_PART_FAR = "SET_PART_FAR";
export const SET_PART_NEAR = "SET_PART_NEAR";
export const SET_PART_SIZE_BOUNDING = "SET_PART_SIZE_BOUNDING";
export const RESET_PART_STATE = "RESET_PART_STATE";
//
